
  import ScreenSize from '@/mixins/ScreenSize';
  import EventBus from '@/events/EventBus';
  import {prepareApiUrl} from '@/helper/UrlHelper';
  import ProfileImageUpload from '@/components/candidate/ProfileImage/ProfileImageUpload';
  import imageToBase64 from '@/helper/imageToBase64';

  export default {
    name: 'ProfileImageRow',
    components: {
      ProfileImageUpload,
    },
    mixins: [ScreenSize],
    props: {
      image: {
        type: [Object, null],
        default: null,
      },
      route: {
        type: String,
        required: true,
      },
      imageType: {
        type: String,
        required: true,
      },
    },
    computed: {
      downloadUrl() {
        if (!this.image) {
          return '';
        }
        return prepareApiUrl(
          process.env.NUXT_ENV_API_PROFILE_IMAGES_FILE_ENDPOINT,
          {
            routeParameters: {id: this.image.id},
            getParameters: {filter: 'thumbnail'},
          }
        );
      },
      fullImageDownloadUrl() {
        if (!this.image) {
          return '';
        }
        return prepareApiUrl(
          process.env.NUXT_ENV_API_PROFILE_IMAGES_FILE_ENDPOINT,
          {
            routeParameters: {id: this.image.id},
            getParameters: {},
          }
        );
      },
    },
    methods: {
      downloadFullImage() {
        if (this.image) {
          imageToBase64(this.fullImageDownloadUrl).then((res) => {
            const a = document.createElement('a');
            a.href = res;
            a.download = this.image.originalName;
            a.click();
          });
        }
      },
      deleteImage() {
        this.$axios
          .delete(
            prepareApiUrl(process.env.NUXT_ENV_API_PROFILE_IMAGES_ENDPOINT, {
              routeParameters: {id: this.image.id},
            })
          )
          .then(() => {
            this.$auth.fetchUser().then(() => {
              this.$store
                .dispatch('profileCompleteness/calculateProfileCompleteness')
                .then(() => {
                  EventBus.$emit('profile-image-delete');
                });
            });

            this.$notifications.showNotification({
              message: 'Bild wurde gelöscht',
              color: 'success',
              timeout: 5000,
            });
          });
      },
      getImagePlaceholder(image, imageType) {
        let imageName = '';
        if (image && this.isMobile) {
          imageName =
            image.originalName && image.originalName.length > 10
              ? image.originalName.slice(0, 10) +
                '...' +
                image.mimeType.slice(-3)
              : '';
        }
        if (image && !this.isMobile) {
          imageName =
            image.originalName && image.originalName.length > 16
              ? image.originalName.slice(0, 16) +
                '...' +
                image.mimeType.slice(-3)
              : '';
        }
        return image
          ? imageName !== ''
            ? imageName
            : image.originalName
          : this.$t('profile_image.action_upload', {
              image_type: this.$t('profile_image.type.' + imageType),
            });
      },
    },
  };
